import { render, staticRenderFns } from "./carousal.vue?vue&type=template&id=63ef5bd4&scoped=true"
import script from "./carousal.vue?vue&type=script&lang=js"
export * from "./carousal.vue?vue&type=script&lang=js"
import style0 from "./carousal.vue?vue&type=style&index=0&id=63ef5bd4&prod&scoped=true&lang=css"
import style1 from "./carousal.vue?vue&type=style&index=1&id=63ef5bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ef5bd4",
  null
  
)

export default component.exports